export const splitStringByDelimiter = (string, delimiter = '|') => string.split(delimiter);
